import React from "react";
import OffertsForm from "../pages/OffertsPage/OffertsForm";
import { entities } from "../utilis/entitiesNames";
import CoworkerForm from "./CoworkerForm";
import MaklersForm from "./MaklersForm";
import PartnersForm from "./PartnersForm";
import NotesForm from "../pages/NotesPage/NotesForm";

export default function BFormWrapper({ name, onSubmit, responseErrors, success }) {
  const getNameWithoutLastChar = () => {
    return name.substring(0, name.length - 1);
  };

  if (name == entities.NOTES) {
    return (
      <NotesForm
        btnText='Speichern'
        onSubmit={onSubmit}
        responseErrors={responseErrors}
        success={success}
      />
    );
  } else if (name == entities.BROKERS) {
    return (
      <MaklersForm
        btnText='Addieren Makler'
        onSubmit={onSubmit}
        responseErrors={responseErrors}
        success={success}
      />
    );
  } else if (name == entities.PARTNERS) {
    return (
      <PartnersForm
        btnText='Addieren Kooperationspartner'
        onSubmit={onSubmit}
        responseErrors={responseErrors}
        success={success}
      />
    );
  } else if (name == entities.COWORKERS) {
    return (
        <CoworkerForm
        btnText='Addieren Mitarbeiter'
        onSubmit={onSubmit}
        responseErrors={responseErrors}
        success={success}
      />
    );
  } else {
    return (
      <OffertsForm
        btnText='Addieren Angebote'
        onSubmit={onSubmit}
        success={success}
        responseErrors={responseErrors}
      />
    );
  }
}
